export const APP_STARTED = 'APP_STARTED';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const INITIALIZE_ADMIN_AUTH = 'INITIALIZE_ADMIN_AUTH';
export const LOGIN_VERIFY_CHECKED = 'LOGIN_VERIFY_CHECKED';
export const APP_INTEGRATIONS_REQUESTED = 'APP_INTEGRATIONS_REQUESTED';
export const APP_INTEGRATIONS_RECEIVED = 'APP_INTEGRATIONS_RECEIVED';
export const APP_INTEGRATIONS_FAILED = 'APP_INTEGRATIONS_FAILED';
export const APP_CONNECTION_CANCELLED = 'APP_CONNECTION_CANCELLED';
export const APP_CONNECTION_ADMIN_REQUIRED = 'APP_CONNECTION_ADMIN_REQUIRED';
export const APP_CONNECTION_INVALID_LICENSE = 'APP_CONNECTION_INVALID_LICENSE';
export const APP_CONNECTION_PERMISSIONS_REQUIRED = 'APP_CONNECTION_PERMISSIONS_REQUIRED';
export const APP_CONNECTION_GENERIC_FAILED = 'APP_CONNECTION_GENERIC_FAILED';
export const ADMIN_FETCH_REQUESTED = 'ADMIN_FETCH_REQUESTED';
export const ADMIN_FETCH_RECEIVED = 'ADMIN_FETCH_RECEIVED';
export const ADMIN_FETCH_FAILED = 'ADMIN_FETCH_FAILED';
export const EMAIL_ADMIN_REQUESTED = 'EMAIL_ADMIN_REQUESTED';
export const EMAIL_ADMIN_RECEIVED = 'EMAIL_ADMIN_RECEIVED';
export const EMAIL_ADMIN_FAILED = 'EMAIL_ADMIN_FAILED';
export const HUB_FETCH_REQUESTED = 'HUB_FETCH_REQUESTED';
export const HUB_FETCH_RECEIVED = 'HUB_FETCH_RECEIVED';
export const HUB_FETCH_FAILED = 'HUB_FETCH_FAILED';
export const ALL_COLLECTIONS_COLLECTION_FETCH_REQUESTED = 'ALL_COLLECTIONS_COLLECTION_FETCH_REQUESTED';
export const ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED = 'ALL_COLLECTIONS_COLLECTION_FETCH_RECEIVED';
export const ALL_COLLECTIONS_COLLECTION_FETCH_FAILED = 'ALL_COLLECTIONS_COLLECTION_FETCH_FAILED';
export const DETAILS_FETCH_REQUESTED = 'DETAILS_FETCH_REQUESTED';
export const DETAILS_FETCH_RECEIVED = 'DETAILS_FETCH_RECEIVED';
export const DETAILS_FETCH_FAILED = 'DETAILS_FETCH_FAILED';
export const DETAILS_REVIEWABILITY_REQUESTED = 'DETAILS_REVIEWABILITY_REQUESTED';
export const DETAILS_REVIEWABILITY_RECEIVED = 'DETAILS_REVIEWABILITY_RECEIVED';
export const DETAILS_REVIEWABILITY_FAILED = 'DETAILS_REVIEWABILITY_FAILED';
export const FEATURE_COMPATIBILITY_REQUESTED = 'FEATURE_COMPATIBILITY_REQUESTED';
export const FEATURE_COMPATIBILITY_RECEIVED = 'FEATURE_COMPATIBILITY_RECEIVED';
export const FEATURE_COMPATIBILITY_FAILED = 'FEATURE_COMPATIBILITY_FAILED';
export const REVIEW_WRITE_REQUESTED = 'REVIEW_WRITE_REQUESTED';
export const REVIEW_WRITE_RECEIVED = 'REVIEW_WRITE_RECEIVED';
export const REVIEW_WRITE_FAILED = 'REVIEW_WRITE_FAILED';
export const REVIEWS_FETCH_REQUESTED = 'REVIEWS_FETCH_REQUESTED';
export const REVIEWS_FETCH_RECEIVED = 'REVIEWS_FETCH_RECEIVED';
export const REVIEWS_FETCH_FAILED = 'REVIEWS_FETCH_FAILED';
export const REVIEWS_FETCH_RESET = 'REVIEWS_FETCH_RESET';
export const REVIEW_FILTERS_UPDATED = 'REVIEW_FILTERS_UPDATED';
export const NEW_REVIEW_SUBMITTED = 'NEW_REVIEW_SUBMITTED';
export const NEW_REVIEW_SUBMITTED_SUCCESS = 'NEW_REVIEW_SUBMITTED_SUCCESS';
export const REVIEWS_STATS_REQUESTED = 'REVIEWS_STATS_REQUESTED';
export const REVIEWS_STATS_RECEIVED = 'REVIEWS_STATS_RECEIVED';
export const REVIEWS_STATS_FAILED = 'REVIEWS_STATS_FAILED';
export const REVIEWS_STATS_RESET = 'REVIEWS_STATS_RESET';
export const REVIEW_HELPFUL_REQUESTED = 'REVIEW_HELPFUL_REQUESTED';
export const REVIEW_HELPFUL_RECEIVED = 'REVIEW_HELPFUL_RECEIVED';
export const REVIEW_HELPFUL_FAILED = 'REVIEW_HELPFUL_FAILED';
export const REVIEW_REPORT_REQUESTED = 'REVIEW_REPORT_REQUESTED';
export const REVIEW_REPORT_RECEIVED = 'REVIEW_REPORT_RECEIVED';
export const REVIEW_REPORT_FAILED = 'REVIEW_REPORT_FAILED';
export const REVIEW_REPORT_REPLY_REQUESTED = 'REVIEW_REPORT_REPLY_REQUESTED';
export const REVIEW_REPORT_REPLY_RECEIVED = 'REVIEW_REPORT_REPLY_RECEIVED';
export const REVIEW_REPORT_REPLY_FAILED = 'REVIEW_REPORT_REPLY_FAILED';
export const DETAILS_MORE_APPS_FETCH_REQUESTED = 'DETAILS_MORE_APPS_FETCH_REQUESTED';
export const DETAILS_MORE_APPS_FETCH_RECEIVED = 'DETAILS_MORE_APPS_FETCH_RECEIVED';
export const DETAILS_MORE_APPS_FETCH_FAILED = 'DETAILS_MORE_APPS_FETCH_FAILED';
export const DETAILS_MORE_APPS_RESET = 'DETAILS_MORE_APPS_RESET';
export const DETAILS_REFERRER_SET = 'DETAILS_REFERRER_SET';
export const DETAILS_REFERRER_RESET = 'DETAILS_REFERRER_RESET';
export const FEATURED_CALLOUTS_REQUESTED = 'FEATURED_CALLOUTS_REQUESTED';
export const FEATURED_CALLOUTS_RECEIVED = 'FEATURED_CALLOUTS_RECEIVED';
export const FEATURED_CALLOUTS_FAILED = 'FEATURED_CALLOUTS_FAILED';
export const COLLECTIONS_REQUESTED = 'COLLECTIONS_REQUESTED';
export const COLLECTIONS_RECEIVED = 'COLLECTIONS_RECEIVED';
export const COLLECTIONS_FAILED = 'COLLECTIONS_FAILED';